<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row">
        <div class="col div-button">
          <button class="btn btn-success mb-2" data-toggle="modal" data-target="#modalNewQuestion" @click="reset()">
            Nueva pregunta
          </button>
        </div>
      </div>

      <div class="row justify-content-end " style="text-align: end;">
        <div class="col-12 col-md-4 col-lg-3 col-xl-3 mb-2">
          <button :hidden="showButtonSaveOrder" class="btn btn-danger btn-block mr-3" @click="clean()">
            Limpiar orden
          </button>
        </div>
        <div class="col-12 col-md-4 col-xl-3 col-lg-3">
          <button :disabled="loading.order" :hidden="showButtonSaveOrder" class="btn btn-info btn-block"
            @click="saveOrders()">
            <template v-if="loading.order">
              <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span>
              Cargando...
            </template>
            <template v-else>Guardar orden </template>
          </button>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col">
          <div class="commentary">
            <span>Para cambiar el orden de las preguntas seleccione uno y arrastrelo a
              la posición deseada</span>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-lg-12">
          <template v-if="loading.history">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" style="width: 4em; height: 4rem;" role="status"></div>
            </div>
          </template>
          <template v-else>
            <div class="table-responsive">
              <table class="table table-striped">
                <caption class="visually-hidden">Listado de Preguntas</caption>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Pregunta</th>
                    <th scope="col">Respuesta</th>
                    <th scope="col">Acción</th>
                  </tr>
                </thead>
                <draggable v-model="questionList" tag="tbody">
                  <tr style="text-align: initial" v-for="item in questionList" :key="item.id">
                    <td style="text-align: center">{{ item.id }}</td>
                    <td style="text-align: center">{{ item.title }} </td>
                    <td style="text-align: center"> {{ item.answer }} </td>
                    <td style="text-align: center">
                      <div style="text-align: center" class="btn-group" role="group">
                        <button class="btn btn-secondary" title="Editar" data-toggle="modal"
                          data-target="#modalUpdateQuestion" @click="edit(item)">
                          Editar
                        </button>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- Modal Nueva pregunta -->
    <div class="modal fade " id="modalNewQuestion" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>Ingrese su nueva pregunta con respuesta</strong> </label><br />
              </div>
              <div class="form-group col-12">
                <div class="mb-3">
                  <div class="input-group ">
                    <input v-model="form.question" type="text" :class="{ 'is-danger': errorsQuestion }"
                      class="form-control" placeholder="Pregunta *" />
                  </div>
                  <span v-if="errorsQuestion"
                    class="text-danger float-left small error-danger">{{ errorsQuestion }}</span>
                </div>
                <div class="mb-3">
                  <div class="input-group ">
                    <textarea rows="5" v-model="form.answer" type="text" :class="{ 'is-danger': errorsAnswer }"
                      class="form-control" placeholder="Respuesta *">
                    </textarea>
                  </div>
                  <span v-if="errorsAnswer" class="text-danger float-left small error-danger">{{ errorsAnswer }}</span>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button data-dismiss="modal" type="button" class="btn btn-secondary btn-sm btn-block button-login">
                  Cancelar
                </button>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button @click="createQuestion()" type="button" class="btn btn-danger btn-sm btn-block button-login">
                  <span v-if="loading.publicate" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  <template v-else>Crear</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Editar pregunta -->
    <div class="modal fade " id="modalUpdateQuestion" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;"><strong>Editar pregunta</strong></label><br>
              </div>
              <div class="form-group col-12">
                <div class="row mb-3">
                  <label for="title">Pregunta: </label>
                  <input id="title" v-model="form.question" type="text" :class="{ 'is-danger': errorsQuestion }"
                    class="form-control" placeholder="Pregunta *" />
                  <span v-if="errorsQuestion"
                    class="text-danger float-left small error-danger">{{ errorsQuestion }}</span>
                </div>
                <div class="row mb-3">
                  <label for="answer">Respuesta: </label>
                  <textarea rows="5" id="answer" v-model="form.answer" type="text"
                    :class="{ 'is-danger': errorsAnswer }" class="form-control" placeholder="Respuesta *">
                  </textarea>
                  <span v-if="errorsAnswer" class="text-danger float-left small error-danger">{{ errorsAnswer }}</span>
                </div>
                <div class="row mb-3">
                  <label for="status">Estado de publicación: </label>
                  <select class="form-control" name="state" id="state" v-model="form.state" placeholder="Estado"
                    :class="{ 'is-danger': errorsStatus }">
                    <option value="0" disabled selected>Seleccione</option>
                    <option value="1">Activo</option>
                    <option value="2">Inactivo</option>
                  </select>
                  <span v-if="errorsStatus" class="text-danger float-left small error-danger">{{ errorsStatus }}</span>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button data-dismiss="modal" type="button" class="btn btn-secondary btn-sm btn-block button-login">
                  Cancelar
                </button>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button @click="updateQuestion()" type="button" class="btn btn-danger btn-sm btn-block button-login">
                  <span v-if="loading.changeDoc" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  <template v-else>Editar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import $ from "jquery";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        num: 1,
        questionList: [],
        listAux: [],
        loading: {
          publicate: false,
          history: false,
          changeDoc: false,
          order: false
        },
        errorsQuestion: false,
        errorsAnswer: false,
        errorsStatus: false,
        form: {
          id: 0,
          question: "",
          answer: "",
          state: 0
        },
        showButtonSaveOrder: false,
        currentList: []
      };
    },
    methods: {
      saveOrders() {
        var listOrders = [];
        var cont = 4; // 4 por que hay 3 por defecto
        for (let i = 0; i < this.questionList.length; i++) {
          listOrders.push({
            id: this.questionList[i].id,
            order: cont++
          });
        }
        var data = {
          orders: listOrders
        };
        this.loading.order = true;
        axios
          .post("superAdmin/question/setOrder", data)
          .then(res => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message
              });
              this.getRequets();
              this.showButtonSaveOrder = true;
            }
            this.loading.order = false;
          })
          .catch(error => {
            this.loading.order = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      clean() {
        this.questionList = this.currentList;
      },
      validform() {
        let app = this;
        if (!app.form.question) {
          app.errorsQuestion = "La pregunta es requerida.";
        }
        if (!app.form.answer) {
          app.errorsAnswer = "La respuesta es requerida.";
        }
        if (!app.errorsQuestion && !app.errorsAnswer) {
          return true;
        }
        return false;
      },
      createQuestion() {
        if (this.validform()) {
          console.log("good");
          let app = this;
          this.postCreate(app.form);
        }
      },
      updateQuestion() {
        if (this.validform()) {
          console.log("good");
          let app = this;
          this.postUpdate(app.form);
        }
      },
      reset() {
        let app = this;
        app.form.question = "";
        app.form.answer = "";
        app.form.state = 0;
        setTimeout(() => {
          app.errorsQuestion = false;
          app.errorsAnswer = false;
          app.errorsStatus = false;
        }, 0);
      },
      deleteQuestion() {
        console.log("Eliminado");
      },
      deleteData(banner) {
        let app = this;
        app.form.id = banner.id;
      },
      edit(item) {
        let app = this;
        app.errorsQuestion = false;
        app.errorsAnswer = false;
        app.errorsStatus = false;
        console.log("Edit question");
        app.form.id = item.id;
        app.form.question = item.title;
        app.form.answer = item.answer;
        app.form.state = item.status_id;
        return item;
      },
      getRequets() {
        this.listAux = this.questionList;
        console.log(this.listAux);
        this.loading.history = true;
        axios
          .get("superAdmin/question/getActive")
          .then(res => {
            console.log(res.data.data);
            if (res.data.cod == 0) {
              this.questionList = res.data.data;
              this.currentList = res.data.data;
            }
            this.loading.history = false;
          })
          .catch(error => {
            this.loading.history = false;
            console.log(error);
          });
      },
      postCreate(form) {
        var data = {
          title: this.form.question,
          answer: this.form.answer
        };
        this.loading.publicate = true;
        axios
          .post("superAdmin/question/create", data)
          .then(res => {
            console.log(res.data.data);
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message
              });
              this.reset();
              this.getRequets();
              $("#modalNewQuestion").modal("hide");
            }
            this.loading.publicate = false;
          })
          .catch(error => {
            this.loading.publicate = false;
            console.log(error);
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      postUpdate(form) {
        var data = {
          title: form.question,
          answer: form.answer,
          statusId: form.state,
          id: form.id
        };
        this.loading.changeDoc = true;
        axios
          .post("superAdmin/question/edit", data)
          .then(res => {
            console.log(res.data.data);
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message
              });
              this.getRequets();
              $("#modalUpdateQuestion").modal("hide");
            }
            this.loading.changeDoc = false;
          })
          .catch(error => {
            this.loading.changeDoc = false;
            console.log(error);
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      postOrder() {
        axios
          .post("superAdmin/question/setOrder", formData)
          .then(res => {
            console.log(res.data.data);
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message
              });
              this.loading.changeDoc = false;
            }
          })
          .catch(error => {
            this.loading.changeDoc = false;
            console.log(error);
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      handleDrop: function (data, event) {
        this.showButtonSaveOrder = true;
        let app = this;
        let dataOrder = {
          order: data.draggedContext.futureIndex,
          id: data.draggedContext.element.id
        };
        app.orderList.push(dataOrder);
      }
    },

    mounted() {
      console.log("lalalal");
      this.getRequets();
    },
    watch: {
      questionList: function (newL) {
        var cont = 0;
        for (let i = 0; i < this.currentList.length; i++) {
          if (this.currentList[i].id != newL[i].id) {
            cont++;
          }
        }
        if (cont > 0) {
          this.showButtonSaveOrder = false;
        } else {
          this.showButtonSaveOrder = true;
        }
      },
      "form.question": function (n) {
        if (n == 0) {
          this.errorsQuestion = "La pregunta es requerida.";
        } else {
          this.errorsQuestion = false;
        }
      },
      "form.answer": function (n) {
        if (n == 0) {
          this.errorsAnswer = "La respuesta es requerida.";
        } else {
          this.errorsAnswer = false;
        }
      },
      "form.state": function (n) {
        if (n != 0) {
          this.errorsStatus = false;
        } else {
          this.errorsStatus = "El estado es requerido.";
        }
      }
    }
  };
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
td {
  cursor: all-scroll;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>